import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HeaderComponent } from './common/header/header.component';
import { HamburgerMenuComponent } from './common/hamburger-menu/hamburger-menu.component';
import { FooterComponent } from './common/footer/footer.component';
import { SearchComponent } from './common/search/search.component';
import { SearchMobileComponent } from './common/search-mobile/search-mobile.component';
import { WebinarComponent } from './pages/webinar/webinar.component';
import { DurationPipe } from './pipe/duration.pipe';
import { BlockCopyPasteDirective } from './directive/block-copy-paste.directive';
import { AlphaOnlyDirective } from './directive/alpha-only.directive';
import { UnstoppableComponent } from './pages/unstoppable/unstoppable.component';
import { AkshayaTritiyaComponent } from './pages/akshaya-tritiya/akshaya-tritiya.component';
import { WishSipComponent } from './pages/wish-sip/wish-sip.component';
import { BajajHeaderComponent } from './common/bajaj-header/bajaj-header.component';
import { ConversionsPipe } from './pipe/conversions.pipe';
import { WishSipVisComponent } from './pages/wish-sip-vis/wish-sip-vis.component';
import { KhushiyonKiInvestmentComponent } from './pages/khushiyon-ki-investment/khushiyon-ki-investment.component';
import { ColorMyDreamsComponent } from './pages/color-my-dreams/color-my-dreams.component';
import { TaxSavingsComponent } from './pages/tax-savings/tax-savings.component';
import { WishsipthankyouComponent } from './pages/wishsipthankyou/wishsipthankyou.component';
import { LpSipComponent } from './pages/lp-sip/lp-sip.component';
import { SipCampaignComponent } from './pages/sip-campaign/sip-campaign.component';
import { SharedPipeModule } from './shared-pipe/shared-pipe.module';
import { CasautomationComponent } from './pages/casautomation/casautomation.component';
import { PickleballComponent } from './pages/pickleball/pickleball.component';
import { ThankYouComponent } from './pages/thank-you/thank-you.component';
import { NewInvestmentComponent } from './pages/new-investment/new-investment.component';
import { WealthLensReport } from './pages/wealthLens-report/wealthLens-report.component';
import { WealthLensReportViewComponent } from './pages/wealthLens-report-view/wealthLens-report-view.component';
import { WealthLensReportTempComponent } from './pages/wealthLens-report-temp/wealthLens-report-temp.component';
import { PortfolioReviewComponent } from './pages/portfolio-review/portfolio-review.component';
import { NewCampaignComponent } from './pages/new-campaign/new-campaign.component';
import { NewCampaignWAComponent } from './pages/new-camp-wa/new-camp-wa.component';
import { RealestateEldecoComponent } from './realestate-eldeco/realestate-eldeco.component';

declare global {
  interface Window {
    webengage?: any;
    appRunner?: any;
  }
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HamburgerMenuComponent,
    SearchComponent,
    SearchMobileComponent,
    WebinarComponent,
    DurationPipe,
    BlockCopyPasteDirective,
    AlphaOnlyDirective,
    TaxSavingsComponent,
    UnstoppableComponent,
    AkshayaTritiyaComponent,
    BajajHeaderComponent,
    ConversionsPipe,
    WishSipComponent,
    WishSipVisComponent,
    KhushiyonKiInvestmentComponent,
    ColorMyDreamsComponent,
    WishsipthankyouComponent,
    LpSipComponent,
    SipCampaignComponent,
    CasautomationComponent,
    PickleballComponent,
    ThankYouComponent,
    NewInvestmentComponent,
    WealthLensReport,
    WealthLensReportViewComponent,
    WealthLensReportTempComponent,
    PortfolioReviewComponent,
    NewCampaignComponent,
    NewCampaignWAComponent,
    RealestateEldecoComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AutocompleteLibModule,
    AppRoutingModule,
    SharedPipeModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
